import React, { useEffect, useState } from 'react';
import { useServicesContext } from '@oneaudi/vtp-shared';
import { ContentService } from '@oneaudi/content-service';
import { useI18n } from '@oneaudi/i18n-context';
import { TextButton } from '@oneaudi/unified-web-components';
import { BackButtonLabel } from '../../styles/ConversionBar.styles';

export const Backlink: React.FC<any> = () => {
  const audiContentService = useServicesContext().getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const content = audiContentService.getContent();
  const { vtpConfiguration, searchLink } = content.fields;
  const scStartPageLink = vtpConfiguration?.fields?.urls_scStartPageLink;
  const backButtonLabel = useI18n({
    defaultMessage: 'Back to search page',
    id: `nemo.ui.sc.details.conversionbar.searchpage`,
  });
  const [browserBack, setBrowserBack] = useState(false);
  useEffect(() => {
    const previousPage = document.referrer;
    const hasPreviousPage = previousPage !== '';
    let isFromSameStockMarket = false;
    if (scStartPageLink) {
      isFromSameStockMarket = previousPage.includes(scStartPageLink);
    }
    const urlDetailSubstring = 'details';
    const isPreviousDetailPage = previousPage.search(`/${urlDetailSubstring}/i`) > 0;

    if (
      hasPreviousPage &&
      !isPreviousDetailPage &&
      isFromSameStockMarket &&
      window.history.length > 1
    ) {
      setBrowserBack(true);
    }
  }, []);

  const urlChangeEvent = () => {
    setBrowserBack(false);
  };
  useEffect(() => {
    window.addEventListener('popstate', urlChangeEvent);
    return () => {
      window.removeEventListener('popstate', urlChangeEvent);
    };
  }, []);
  const clickHandler = (e: React.MouseEvent) => {
    if (browserBack) {
      e.preventDefault();
      window.history.back();
    }
  };

  return (
    <TextButton
      variant="tertiary"
      onClick={clickHandler}
      href={searchLink}
      icon="back"
      iconPosition="leading"
      size="sm"
    >
      <BackButtonLabel>{backButtonLabel}</BackButtonLabel>
    </TextButton>
  );
};
